var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 6.66615H14.1673C14.8304 6.66615 15.4662 6.92954 15.9351 7.39838C16.4039 7.86722 16.6673 8.5031 16.6673 9.16615V15.8328C16.6673 16.4959 16.4039 17.1317 15.9351 17.6006C15.4662 18.0694 14.8304 18.3328 14.1673 18.3328H5.83398C5.17094 18.3328 4.53506 18.0694 4.06622 17.6006C3.59738 17.1317 3.33398 16.4959 3.33398 15.8328V9.16615C3.33398 8.5031 3.59738 7.86722 4.06622 7.39838C4.53506 6.92954 5.17094 6.66615 5.83398 6.66615H6.66732V5.09115C6.66732 4.20709 7.01851 3.35924 7.64363 2.73412C8.26875 2.109 9.1166 1.75781 10.0007 1.75781C10.8847 1.75781 11.7326 2.109 12.3577 2.73412C12.9828 3.35924 13.334 4.20709 13.334 5.09115V6.66615ZM8.80422 3.86781C8.49186 4.19735 8.32277 4.63723 8.33398 5.09115V6.66615H11.6673V5.09115C11.6785 4.63723 11.5094 4.19735 11.1971 3.86781C10.8847 3.53827 10.4545 3.3459 10.0007 3.33281C9.54678 3.3459 9.11658 3.53827 8.80422 3.86781ZM8.84321 10.7674C9.18582 10.5384 9.58861 10.4163 10.0007 10.4163C10.5532 10.4163 11.0831 10.6358 11.4738 11.0265C11.8645 11.4172 12.084 11.9471 12.084 12.4996C12.084 12.9116 11.9618 13.3144 11.7329 13.657C11.504 13.9996 11.1786 14.2667 10.7979 14.4243C10.4172 14.582 9.99834 14.6233 9.59421 14.5429C9.19009 14.4625 8.81887 14.2641 8.52751 13.9727C8.23615 13.6814 8.03773 13.3102 7.95735 12.906C7.87696 12.5019 7.91822 12.083 8.0759 11.7023C8.23359 11.3217 8.50061 10.9963 8.84321 10.7674Z",
    fill: "#1271A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.71b78cf42445cc2c55d8640c09113d62.svg";
export { ForwardRef as ReactComponent };